import { Button } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { NOTIFICATION_STYLE_LIST } from 'src/constants/queryKeys';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useFormsModalStore from 'src/store/forms';

const NotificationStyleListTableBreadcrumb = ({ title }) => {
  const { setModal } = useFormsModalStore();

  return (
    <HeaderBreadcrumbs
      heading={title}
      links={[
        { name: 'داشبورد', href: PATH_DASHBOARD.general.home },
        { name: title, href: null },
      ]}
      action={
        <Button
          variant="contained"
          startIcon={<Iconify icon={'eva:plus-fill'} />}
          onClick={() => setModal({ isOpen: true, type: NOTIFICATION_STYLE_LIST, data: null, title: 'ایجاد فریم جدید' })}
        >
          ایجاد فریم جدید
        </Button>
      }
    />
  );
};

export default NotificationStyleListTableBreadcrumb;
